<template>
  <div class="discount">
    <img :src="discountImg"/>
  </div>
</template>

<script>
const discountImg = require('@/assets/image/banner/banner20220617.jpg');

export default {
  name: 'discount',
  data() {
    return {
      discountImg,
    };
  },
};
</script>

<style lang="sass" scoped>
@import '../../assets/css/mixins'

.discount
  min-height: 300px
  @include base-wrap
  overflow: hidden

</style>
